
export class ModalRegion extends Mn.Region {

    onShow () {

        this.$el.show();
        this.$el.addClass('app-modal-cnt--shown');

        let selectorToFocus = this.currentView.options.selectorToFocus;

        if (selectorToFocus) {

            let elementToFocus = this.$el.find(selectorToFocus);

            if (elementToFocus.length >= 1) {

                _.head(elementToFocus).focus();
            }
        }
    }

    onEmpty () {

        this.$el.hide();
        this.$el.removeClass('app-modal-cnt--shown');
    }

}


// WEBPACK FOOTER //
// ./shared/view/BasicLayout/ModalRegion/ModalRegion.js